import React, { useEffect, useRef, useState } from "react";
import { axios_instance } from "../api/axios_instance";
import { decryptRequest, encryptRequest } from "../utils/encryptdecryptrequest";
import { toast } from "react-toastify";

const AutoComplete = ({ searchType }) => {
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchOptions = async (input) => {
    setIsLoading(true);
    try {
      const reqData = encryptRequest({ searchValue: input });
      const result = await axios_instance({
        url: "/dts/searchLoanCases",
        method: "POST",
        data: { reqData },
      });
      const resData = decryptRequest(result.data.resData);

      if (result.status === 200) {
        setOptions(resData.result.options);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message
          ? error.response.data.message
          : "Something went wrong",
        { theme: "colored" }
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = async (input) => {
    setInputValue(input);
    if (input.length < 5) {
      setOptions([]);
      return;
    }
    if (!validateSearch(input)) {
      setOptions([]);
      return;
    }
    await fetchOptions(input);
  };

  const validateSearch = (input) => {
    if (searchType === "Loan ID" && !/^[0-9 ]+$/.test(input)) {
      toast.dismiss();
      toast.error("Please enter numeric characters.", { theme: "colored" });
      return false;
    } else if (searchType === "Customer Name" && !/^[a-zA-Z ]+$/.test(input)) {
      toast.dismiss();
      toast.error("Please enter alphabetic characters.", { theme: "colored" });
      return false;
    }
    return true;
  };

  const openDetailPage = (selectedOption) => {
    const url = `/payments/details?lead_id=${btoa(selectedOption.value)}`;
    window.open(url, "_blank");
    setInputValue(selectedOption.label);
    setOptions([]);
  };
  const outsideRef = useRef(null);

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (outsideRef.current && !outsideRef.current.contains(e.target))
        setOptions([]);
    };
    document.addEventListener("click", checkIfClickedOutside);
    return () => {
      document.removeEventListener("click", checkIfClickedOutside);
    };
  });

  return (
    <span className="autocomplete-main-wrapper">
      <input
        type="text"
        id="case_search_input"
        className="form-control ui-autocomplete-loading-custom"
        title={searchType}
        placeholder={searchType}
        value={inputValue}
        onChange={(e) => handleInputChange(e.target.value)}
      />
      {isLoading ? (
        <img
          src={`${process.env.REACT_APP_STYLES_PATH}page-loader.gif`}
          alt=""
          className="search-bar-spinner"
        />
      ) : (
        ""
      )}

      <div className="autocomplete-box" ref={outsideRef}>
        <div className="autocomplete-suggestions">
          {options.map((option, index) => {
            const arr = option.label.split(inputValue);
            return (
              <div
                className="autocomplete-suggestion"
                key={index}
                onClick={() => option.value && openDetailPage(option)}
              >
                {arr.map((val, idx) => {
                  return (
                    <span key={idx}>
                      {val}
                      {idx !== arr.length - 1 ? (
                        <strong className="matched-suggestion-text">
                          {inputValue}
                        </strong>
                      ) : (
                        ""
                      )}
                    </span>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </span>
  );
};

export default AutoComplete;
